import { useEffect, useLayoutEffect as useLayoutEffect_ } from 'react'
const useLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect_ : useEffect
export default useLayoutEffect
